module.exports = __webpack_public_path__ + "img/IMG_20191125_200951.78d97ba7.jpg";